// src/components/Layout.tsx
import React from "react";
import { Outlet } from "react-router-dom";

export default function Layout() {
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-slate-950 via-slate-900 to-emerald-950/40 bg-fixed text-white">
      {/* voile léger pour la lisibilité, sans sidebar */}
      <div className="min-h-screen flex flex-col bg-black/45">
        {/* Header compact */}
        <header className="w-full flex items-center justify-between px-6 py-3 bg-slate-900/70 backdrop-blur border-b border-white/10">
          <div className="flex items-center gap-3">
            <img src="/vite.svg" alt="EspoirAfriqueSas" className="h-8 w-8" />
            <span className="font-semibold tracking-wide">
              EspoirAfriqueSas — Smart APP
            </span>
          </div>
        </header>

        {/* Contenu des pages */}
        <main className="flex-1">
          {/* Laisse les pages décider de leur mise en page (container, cartes, etc.) */}
          <Outlet />
        </main>

        {/* Footer */}
        <footer className="w-full text-center text-xs md:text-sm text-gray-200/90 px-4 py-3 bg-slate-900/70 backdrop-blur border-t border-white/10">
          © {new Date().getFullYear()} EspoirAfriqueSas — Tous droits réservés.
        </footer>
      </div>
    </div>
  );
}